import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import IconButton from '~/components/IconButton';
import history from '~/services/history';

const renderVehicle = c => {
  const plate = c?.vehicle_plate || c?.courier_vehicle_data?.plate;
  const make = c?.vehicle_make || c?.courier_vehicle_data?.make;
  const model = c?.vehicle_model || c?.courier_vehicle_data?.model;
  const color = c?.vehicle_color || c?.courier_vehicle_data?.color;
  const type = c?.vehicle_type || c?.courier_vehicle_data?.type;

  const parts = [
    plate ? `Placa: ${plate}` : null,
    make || model ? `${[make, model].filter(Boolean).join(' ')}` : null,
    color ? `Cor: ${color}` : null,
    type ? `Tipo: ${type}` : null,
  ].filter(Boolean);

  return parts.length ? parts.join(' • ') : '—';
};

const CourierBlacklistCard = ({ courier, onDelete }) => {
  return (
    <Card className="card new-layout list-card grow-on-hover">
      <CardBody className="card-body new-layout px-3 py-3">
        <Row className="w-100 h-100 mx-0 d-none d-md-flex">
          <Col
            xs={4}
            align="start"
            className="h-100 d-flex flex-column justify-content-center"
          >
            <div className="new-layout-card-list-strong-value w-100">
              {courier?.name || 'Sem nome'}
              <div className="text-muted small">
                ID externo: {courier?.courier_external_id || '—'}
              </div>
            </div>
          </Col>
          <Col
            xs={2}
            align="start"
            className="h-100 d-flex flex-column justify-content-center"
          >
            <div className="new-layout-table-column-value">
              {courier?.telephone || '—'}
            </div>
          </Col>
          <Col xs={2} align="center" className="h-100">
            <div className="new-layout-table-column-value h-100 text-truncate">
              <div className="badge badge-light">
                {courier?.delivery_method || '—'}
              </div>
            </div>
          </Col>
          <Col xs={3} align="start" className="h-100 d-flex flex-row flex-wrap">
            <div className="new-layout-table-column-value h-100 text-truncate">
              <div className="text-truncate">{renderVehicle(courier)}</div>
            </div>
          </Col>
          <Col xs={1} align="center" className="h-100">
            <div className="h-100 d-flex flex-row align-items-center justify-content-around">
              <IconButton
                icon="las la-pen"
                color="primary"
                id={`edit-btn-${courier.id}`}
                tip="Editar"
                forceTip
                click={() => {
                  history.push(
                    `/entregadores-bloqueados/perfil/${courier.id}/editar`
                  );
                }}
              />
              <IconButton
                icon="las la-trash"
                color="danger"
                id={`delete-btn-${courier.id}`}
                tip="Excluir"
                forceTip
                click={() => onDelete(courier)}
              />
            </div>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
};

export default CourierBlacklistCard;
